module.exports = __webpack_public_path__ + "fe5bde11e6c7bf2690f10da7681ab5a2.png";